import { Pipe, PipeTransform } from '@angular/core';
import { Address, DetailedAddress } from '@apaq/orgkit-js';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(address: Address, args?: any): any {
    if (address == null || 
      (address.street == null && address.apartment == null && address.postalCode == null && address.city == null)) {
      return $localize`Undefined`;
    }

    let streetAndHouse: string | undefined;

    if (!this.isDetailed(address)) {
      streetAndHouse = address.street ?? '';
    } else {
      streetAndHouse = address.street == null ? undefined : `${address.street} ${address.houseNumber}`;
    }

    let result = '';
    if(streetAndHouse) {
      result += streetAndHouse;
    } else {
      result += '-';
    }

    if(address.postalCode || address.city) {
      result += ', ';
      result += address.postalCode ? address.postalCode + ' ' : '';
      result += address.city ? address.city : '';
    }

    return result.trim();
  }

  isDetailed(entity: Address): entity is DetailedAddress {
    return (<DetailedAddress>entity).houseNumber !== undefined;
  }

}
